var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 16,
    viewBox: "0 0 46 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4169 15.0548H7.52246L4.60211 3.93537C4.46349 3.42387 4.16918 2.97169 3.73625 2.75856C2.65583 2.22298 1.46528 1.79674 0.166504 1.58176V1.15366H6.44015C7.306 1.15366 7.95539 1.79674 8.06362 2.54359L9.57887 10.5644L13.4714 1.15366H17.2576L11.4169 15.0548ZM19.4223 15.0548H15.7443L18.7729 1.15366H22.4509L19.4223 15.0548ZM27.2092 5.00498C27.3175 4.25627 27.9668 3.82817 28.7245 3.82817C29.915 3.72069 31.2119 3.93566 32.2942 4.46939L32.9436 1.47642C31.8613 1.04833 30.6707 0.833351 29.5903 0.833351C26.0206 0.833351 23.423 2.75886 23.423 5.43122C23.423 7.46422 25.2629 8.53168 26.5617 9.17475C27.9668 9.81597 28.508 10.2441 28.3998 10.8853C28.3998 11.8471 27.3175 12.2752 26.237 12.2752C24.9383 12.2752 23.6395 11.9546 22.4508 11.419L21.8014 14.4138C23.1002 14.9476 24.5053 15.1625 25.8041 15.1625C29.8068 15.2682 32.2942 13.3445 32.2942 10.4572C32.2942 6.82114 27.2092 6.60802 27.2092 5.00498V5.00498ZM45.1666 15.0548L42.2462 1.15366H39.1094C38.46 1.15366 37.8106 1.58176 37.5942 2.22298L32.1864 15.0548H35.9726L36.7283 13.0236H41.3804L41.8133 15.0548H45.1666ZM39.6505 4.8974L40.7309 10.1365H37.7023L39.6505 4.8974Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.51a8a381b0f89f61f3b5e6e06750ccc4.svg";
export { ForwardRef as ReactComponent };